import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { DialogModal } from 'components';

class PlayPlaylistModal extends React.Component {
	static propTypes = {
		playlist: PropTypes.object,
		onClickYes: PropTypes.func,
		onClickCancel: PropTypes.func,
		t: PropTypes.func
	}

	render() {
		const { playlist, t, onClickYes, onClickCancel } = this.props;
		return (
			<DialogModal
				title={t('playlist.replace-warning-title')}
				onClickYes={onClickYes}
				onClickCancel={onClickCancel}>
				<div className="flex flex-col items-center mx-10 my-6 text-center break-words-everywhere">
					<div>
						{t('playlist.replace-warning-message').replace(
							'%@playlist',
							playlist.name
						)}
					</div>
				</div>
			</DialogModal>
		);
	}
}

export default withTranslation()(PlayPlaylistModal);
